__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-international-shop-root'].baseUrl;
import ModuleContainer from './components/AxpInternationalShopRoot';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    '@americanexpress/data-manager-utils': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.4.5',
      module: require('@americanexpress/data-manager-utils')
    },
    'axp-product-ducks': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.4.24',
      module: require('axp-product-ducks')
    },
    '@americanexpress/one-xp-client-sdk': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.30.0',
      module: require('@americanexpress/one-xp-client-sdk')
    },
    '@americanexpress/one-experiments': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '2.6.0',
      module: require('@americanexpress/one-experiments')
    },
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.5',
      module: require('@americanexpress/react-ddl')
    },
    '@americanexpress/reactlytics': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.2.8',
      module: require('@americanexpress/reactlytics')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'axp-international-shop-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'axp-international-shop-root';
}